export function serializeObjectToQuery(obj) {
  return Object.keys(obj).map((key) => {
    if (Array.isArray(obj[key])) {
      return obj[key].map((elem) => `${encodeURIComponent(key)}=${encodeURIComponent(elem)}`).join('&');
    }
    return `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`;
  }).join('&');
}
